import {
  EmptyState,
  KeyValuePanel,
  Panel,
  TextDataDisplay,
} from "@validereinc/common-components";
import { type WorkerVersionType } from "@validereinc/domain";
import { resolveWorkerVersionComputeConfig } from "@validereinc/domain-controllers";
import React, { useMemo } from "react";

export const WorkerVersionComputeConfigPanel = ({
  version,
  noVersionEmptyStateTitle = "Version not found.",
  noVersionEmptyStateSuggestion,
}: {
  version?: WorkerVersionType;
  noVersionEmptyStateTitle?: string;
  noVersionEmptyStateSuggestion?: string;
}) => {
  const data = useMemo(() => {
    if (version == null) {
      return [];
    }

    const { timeoutSeconds, memoryMb } = resolveWorkerVersionComputeConfig(
      version.compute_config
    );

    return [
      {
        title: "Timeout",
        value: <TextDataDisplay value={`${timeoutSeconds} sec`} />,
      },
      {
        title: "Memory",
        value: <TextDataDisplay value={`${memoryMb} MB`} />,
      },
    ];
  }, [version]);

  if (version == null) {
    return (
      <Panel title="Configuration">
        <EmptyState
          title={noVersionEmptyStateTitle}
          suggestion={noVersionEmptyStateSuggestion}
        />
      </Panel>
    );
  }

  return (
    <KeyValuePanel
      data={data}
      panelKeyValueListProps={{ variant: "shaded", color: "neutral" }}
      panelProps={{
        title: "Configuration",
        isFluidY: true,
        loaded: true,
      }}
    />
  );
};
